import React from 'react';
import closeDeliveryIcon from '../../../assets/images/close-orange-symbol.svg';
import closeDineInIcon from '../../../assets/images/close-symbol-restaurant.svg';
import './index.scss';
import { THEME } from '../../constants/app-constants';

const BKModal = ({ children, className = '' }) => {
  return <div className={`bk-modal ${className}`}>{children}</div>;
};

const ContentContainer = ({ children, className = '' }) => {
  return (
    <div
      className={`bk-modal__modal-container ${className}`}
      data-testid="bk-modal__modal-container"
    >
      {children}
    </div>
  );
};

const CloseButton = ({
  onClose,
  src = '',
  className = '',
  iconImageClassName = '',
  theme = THEME.DINE_IN
}) => {
  const handleClose = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  };
  return (
    <div className={`close-icon-container ${className}`} onClick={handleClose}>
      <img
        className={`close-icon ${iconImageClassName}`}
        src={src || closeDeliveryIcon}
      />
    </div>
  );
};

BKModal.CloseButton = CloseButton;
BKModal.ContentContainer = ContentContainer;

export default BKModal;
